<script setup>
import {ref, computed, onBeforeMount} from 'vue'
import {useRoute, useRouter} from 'vue-router'
import { useProjectStore } from '@/stores/project'
import { useAccessStore } from '@/stores/access'
import MonitoringForm from './MonitoringForm.vue'
import { can } from '@/composables/useCan'

const projectStore = useProjectStore()

const accessStore = useAccessStore()
const route = useRoute()
const router = useRouter()

const projectId = route.params.project_id
const project = computed(() => projectStore.current)
const canRead = ref(false)

onBeforeMount(async () => {
  await projectStore.fetchProject(projectId)
  await accessStore.ensure(route.params.org_id).catch(() => {})
  canRead.value = can('project_settings', 'read', { projectId: Number(projectId) })

  if (!canRead.value) {
    router.push({name: 'ProjectHome', params: {project_id: projectId}})
  }
})
</script>

<template>
  <div class="max-w-[60%] space-y-3" v-if="canRead">
    <MonitoringForm v-if="project.project_id" :project="project" />
  </div>
</template>
